<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Lista de Compras</h6>
              <div class="d-flex gap-2">
                <button
                  v-if="kubappEnabled"
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  @click="syncKubapp"
                  :disabled="isSyncingKubapp"
                >
                  <i class="fa fa-sync me-1" :class="{ 'fa-spin': isSyncingKubapp }"></i>
                  {{ isSyncingKubapp ? 'Sincronizando...' : 'Sincronizar' }}
                </button>
                <router-link
                  :to="{ name: 'Purchases Create' }"
                  class="btn btn-primary btn-sm"
                  data-toggle="tooltip"
                  data-original-title="Agregar compra"
                >
                  Agregar <i class="fa fa-plus ms-1"></i>
                </router-link>
              </div>
            </div>
            <!-- se agg una row mas para la busqueda-->
            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar proveedor..."
                  @input="onSearchInput"
                />
              </div>
              <!-- Columna de fechas -->
              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input
                  type="date"
                  v-model="startDate"
                  id="startDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input
                  type="date"
                  v-model="endDate"
                  id="endDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Proveedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo de Pago
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado de Pago
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.supplier }}</h6>
                          <span v-if="value.kubapp_document" class="text-xs text-secondary">
                            Kubapp {{ value.kubapp_doc_type }}-{{ value.kubapp_document }}
                            <template v-if="value.kubapp_soporte"> · Soporte {{ value.kubapp_soporte }}</template>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value.total).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="getPaymentTypeClass(value.payment_type)">
                        {{ getPaymentTypeText(value.payment_type) }}
                      </span>
                      <div v-if="value.payment_type === 'credito' && value.due_date" class="text-xs text-secondary mt-1">
                        Vence: {{ formatDate(value.due_date) }}
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="getPaymentStatusClass(value)">
                        {{ getPaymentStatusText(value) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ value.kubapp_date ? formatDate(value.kubapp_date) : new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="getStatusClass(value.status)">
                        {{ getStatusText(value.status) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Purchases Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i :class="value.status == 0 ? 'fa fa-pencil-alt' : 'fa fa-eye'"></i>
                      </router-link>


                      <a @click="printPurchase(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Imprimir compra">
                        <i class="fas fa-print"></i>
                      </a>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro"
                        v-if="value.status == 0">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>


              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.url)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import purchasesService from '@/services/purchases.service';
export default {
  name: 'ProjectsList',

  data() {
    return {
      searchQuery: '',
      searchTimeout: null,
      startDate: '',
      endDate: '',
      isSyncingKubapp: false,
    };
  },



  computed: {
    ...mapGetters('purchases', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    ...mapGetters('settings', ['kubappEnabled']),
    currentPage() {
      return this.$store.state.purchases.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.purchases.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['purchases/links']; // Retorna los links
    },
  },

  methods: {
    getStatusClass(status) {
      // Convertir status a número si es string, null o undefined
      if (status === null || status === undefined || status === '') {
        return 'bg-gradient-secondary';
      }
      const statusNum = parseInt(status);
      
      if (isNaN(statusNum)) {
        return 'bg-gradient-secondary';
      }
      
      if (statusNum === 0) {
        return 'bg-gradient-warning'; // Borrador
      } else if (statusNum === 1) {
        return 'bg-gradient-success'; // Formalizada
      } else {
        return 'bg-gradient-secondary'; // Desconocido
      }
    },
    getStatusText(status) {
      // Convertir status a número si es string, null o undefined
      if (status === null || status === undefined || status === '') {
        return 'Sin estado';
      }
      const statusNum = parseInt(status);
      
      if (isNaN(statusNum)) {
        return 'Sin estado';
      }
      
      if (statusNum === 0) {
        return 'Borrador';
      } else if (statusNum === 1) {
        return 'Formalizada';
      } else {
        return 'Desconocido';
      }
    },
    getPaymentStatusClass(purchase) {
      const total = parseFloat(purchase.total || 0);
      const totalPaid = parseFloat(purchase.total_paid || 0);
      const pendingAmount = total - totalPaid;
      
      if (total === 0) {
        return 'bg-gradient-secondary';
      }
      
      if (pendingAmount <= 0) {
        return 'bg-gradient-success'; // Pagado completamente
      } else {
        return 'bg-gradient-warning'; // Pendiente
      }
    },
    getPaymentStatusText(purchase) {
      const total = parseFloat(purchase.total || 0);
      const totalPaid = parseFloat(purchase.total_paid || 0);
      const pendingAmount = total - totalPaid;
      
      if (total === 0) {
        return 'Sin total';
      }
      
      if (pendingAmount <= 0) {
        return 'Pagado';
      } else {
        return 'Pendiente';
      }
    },
    getPaymentTypeClass(paymentType) {
      if (paymentType === 'credito') {
        return 'bg-gradient-info';
      } else {
        return 'bg-gradient-success';
      }
    },
    getPaymentTypeText(paymentType) {
      if (paymentType === 'credito') {
        return 'Crédito';
      } else {
        return 'Contado';
      }
    },
    formatDate(date) {
      if (!date) return '-';
      // Fechas sin hora (YYYY-MM-DD...): se leen como hora local para no correr un día por la zona horaria
      return new Date(String(date).slice(0, 10) + 'T00:00:00').toLocaleDateString('es-ES');
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData(null);
      }, 400);
    },
    async syncKubapp() {
      if (!this.kubappEnabled || this.isSyncingKubapp) return;

      const confirm = await Swal.fire({
        title: "Sincronizar compras de Kubapp",
        html: "¿Traer las facturas de compra desde Kubapp?<br><small class=\"text-muted\">Se crean las compras nuevas, se actualizan las que cambiaron y se actualiza el precio de compra de los insumos con la misma referencia, también dentro de las producciones pendientes y en producción. El stock no se modifica (llega con la sincronización de inventario).</small>",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sincronizar",
        cancelButtonText: "Cancelar",
      });

      if (!confirm.isConfirmed) return;

      this.isSyncingKubapp = true;
      try {
        const response = await purchasesService.syncKubapp();
        const stats = response.data?.data || {};
        await Swal.fire({
          icon: "success",
          title: "Compras sincronizadas",
          html: `
            <p>${response.data?.message || "Sincronización completada."}</p>
            <p class="text-sm text-secondary">Rango: ${stats.from ?? ''} a ${stats.to ?? ''}</p>
            <ul class="text-start mb-0">
              <li>Facturas encontradas: <strong>${stats.documents ?? 0}</strong></li>
              <li>Creadas: <strong>${stats.created ?? 0}</strong></li>
              <li>Actualizadas: <strong>${stats.updated ?? 0}</strong></li>
              <li>Sin cambios: <strong>${stats.unchanged ?? 0}</strong></li>
              <li>Precios de compra actualizados: <strong>${stats.price_updated ?? 0}</strong></li>
              <li>Insumos de producciones actualizados: <strong>${stats.production_details_updated ?? 0}</strong></li>
              <li>Insumos creados: <strong>${stats.inventory_created ?? 0}</strong></li>
            </ul>
          `,
        });
        this.fetchData();
      } catch (error) {
        console.error('Error al sincronizar compras con Kubapp:', error);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "No se pudieron sincronizar las compras con Kubapp",
        });
      } finally {
        this.isSyncingKubapp = false;
      }
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('purchases/fetchData', params);
    },
    async printPurchase(id) {
      try {
        const response = await this.$store.dispatch("purchases/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Compra_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF de la compra',
        });
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchases/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    }

  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>